import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  children: ReactNode;
  link?: string;
  onClick?: () => void;
  enabled?: boolean;
}

const SecondaryButton = ({
  children,
  link,
  onClick,
  enabled = true,
}: Props) => {
  const nav = useNavigate();

  return (
    <button
      className={`secondary ${!enabled ? "disabled" : ""}`}
      onClick={() =>
        enabled && (onClick?.() ?? link !== undefined ? nav(link!) : () => {})
      }
    >
      <p>{children}</p>
    </button>
  );
};

export default SecondaryButton;
